import createAction from "redux-actions/es/createAction";
import { getChart as api } from "../api/index";
import { getProject as getApi } from "../api/index";
import { getSuitType as getSuitApi } from "../api/index";
import { getTestCases as getTcApi } from "../api/index";
import { getBulkData as getBulkDataApi } from "../api/index";
// import { getDashboard as getDashbaordApi } from "../api/index";
import { getPiechartBulk as getPiechartBulkApi } from "../api/index";
import { getTrendchartBulk as getTrendchartBulkApi } from "../api/index";
import { fetchAnalyticsData as fetchAnalyticsDataApi } from "../api/index";
// import { getuserInfomation as userApi } from "../api/index";
// import { selectDefaultProject as updateProjectApi } from "../api/index";
// import { auth } from "../../../actions/authActions";
import {setDefaultPieChart} from "../../autoation-analytics/actions/index";

export const pieChart = createAction("PIE_CHART_START");
export const pieChartFail = createAction("PIE_CHART_FAIL");
export const pieChartSuccess = createAction("PIE_CHART_SUCCESS");
export const trendChartSuccess = createAction("TREND_CHART_SUCCESS");

export const projectStart = createAction("DEFAULT_PROJECT_START");
export const projectFail = createAction("DEFAULT_PROJECT_FAIL");
export const projectSuccess = createAction("DEFAULT_PROJECT_SUCCESS");

export const suitTypeStart = createAction("SUIT_TYPE_START");
export const suitTypeFail = createAction("SUIT_TYPE_FAIL");
export const suitTypeSuccess = createAction("SUIT_TYPE_SUCCESS");

export const testCasesStart = createAction("TEST_CASES_START");
export const testCasesFail = createAction("TEST_CASES_FAIL");
export const testCasesSuccess = createAction("TEST_CASES_SUCCESS");

export const initalData = createAction("INITIAL_DATA_START");
export const initalDataFail = createAction("INITIAL_DATA_FAIL");
export const initalDataSuccess = createAction("INITIAL_DATA_SUCCESS");
export const initalDataClear = createAction("INITIAL_DATA_CLEAR");

export const piechartBulk = createAction("PIECHART_BULK_START");
export const piechartBulkFail = createAction("PIECHART_BULK_FAIL");
export const piechartBulkSuccess = createAction("PIECHART_BULK_SUCCESS");
export const piechartBulkDataClear = createAction("PIECHART_BULK_CLEAR");

export const trendchartBulk = createAction("TRENDCHART_BULK_START");
export const trendchartBulkFail = createAction("TRENDCHART_BULK_FAIL");
export const trendchartBulkSuccess = createAction("TRENDCHART_BULK_SUCCESS");
export const trendchartBulkDataClear = createAction("TRENDCHART_BULK_CLEAR");


export const userinfomation = createAction("USER_INFORMATION_START");
export const userinfomationFail = createAction("USER_INFORMATION_FAIL");
export const userinfomationSuccess = createAction("USER_INFORMATION_SUCCESS");
export const userinfomationClear = createAction("USER_INFORMATION_CLEAR");

export const fetchAnalytics = createAction("FETCH_ANALYTICS_START");
export const fetchAnalyticsFail = createAction("FETCH_ANALYTICS_FAIL");
export const fetchAnalyticsSuccess = createAction("FETCH_ANALYTICS_SUCCESS");
export const fetchAnalyticsClear = createAction("FETCH_ANALYTICS_CLEAR");

export const fetchPieChart = (values, type, project) => {
  return (dispatch) => {
    api(values, type , project)
      .then((res) => {
        if (type === "trendchart") {
          dispatch(trendChartSuccess(res.data));
        } else {
          dispatch(pieChartSuccess(res.data));
          if(res.config.params.subCategory ){
            dispatch(setDefaultPieChart(res?.data));
          }
  
        }
      })
      .catch((err) => {
        dispatch(pieChartFail(err));
      });
  };
};

export const getProjects = () => {
  return (dispatch) => {
    getApi()
      .then((res) => {
        dispatch(projectSuccess(res.data));
      })
      .catch((err) => {
        dispatch(projectFail(err));
      });
  };
};

export const getSuitType =  (value) => {
  return async (dispatch) => {
    await getSuitApi(value)
      .then((res) => {
        dispatch(suitTypeSuccess(res.data));
      })
      .catch((err) => {
        dispatch(suitTypeFail(err));
      });
  };
};

export const getTestCases = (value, project , dp) => {
  return async (dispatch) => {
    await getTcApi(value, project)
      .then((res) => {
        let obj={projectName:project,
          subCategory:value.subCategory,
          status: (typeof res.data === 'string')?'fail':'success',
          result:(typeof res.data === 'string')?res.data:[res.data]
        }
        dispatch(testCasesSuccess(obj));
        // if(res.config.params.subCategory===dp && typeof res.data !== 'string'){
        //   dispatch(setDefaultPieChart(res?.data?.failedSuiteData));
        // }

       })
      .catch((err) => {
        dispatch(testCasesFail(err));
      });
  };
};


export const getPiechartBulk =   (value, defaultProject) => {
  return  async (dispatch) => {
     return  await getBulkDataApi(value)
      .then((res) => {
         dispatch(piechartBulkSuccess(res.data))
        //  dispatch(getTrendchartBulk(value))
       let defaultPie= res.data.filter(item=>item.pieChartData[defaultProject+'-Status'])[0]['pieChartData'];
       dispatch(setDefaultPieChart(defaultPie));
      })
      .catch((err) => {
        dispatch(piechartBulkFail(err));
      });
  };
};

export const getTrendchartBulk = (value) => {
  return async (dispatch) => {
    return await  getTrendchartBulkApi(value)
      .then((res) => {
         dispatch(trendchartBulkSuccess(res.data));

      })
      .catch((err) => {
         dispatch(trendchartBulkFail(err));
      });
  };
};

export const getTableBulk = (value, project) => {
  return async (dispatch) => {
    return await  fetchAnalyticsDataApi(value ,project)
      .then((res) => {
        let runId=value.runId;
        let obj={};
        obj[runId]=res.data;
         dispatch(fetchAnalyticsSuccess(obj));
      })
      .catch((err,res) => {
          let ErrorMes=err.toString();
        if(ErrorMes.includes('412')){
          let runId=value.runId;
          let obj={};
          obj[runId]={'message': `There is no data found with this runId:${runId}`};
           dispatch(fetchAnalyticsSuccess(obj));
        }
        dispatch(fetchAnalyticsFail(err));
      });
  };
};
// export const getuserInfomation = ()=>{
//   return (dispatch) => {
//    return  userApi()
//      .then((res) => {
//        if(res.status===200){
//         let data=res.data;
//         // dispatch(loadInitClientDataSuccess(data));
//        }
//      })
//      .catch((err) => {
//         dispatch(userinfomationFail(err));
//      });
//  };
// }

// export const updateProjectDetails = (value)=>{
//   return (dispatch) => {
//    return  updateProjectApi(value)
//      .then((res) => {
//        if(res.status===200){
//         return  dispatch(userinfomationSuccess(res.data));
//        }
//      })
//      .catch((err) => {
//         dispatch(userinfomationFail(err));
//      });
//  };
// }